// Keeps everything up to the last visible character and lets the DOM close whatever is still
// open there, so a <br> left between that character and the closing tags (an empty line's
// placeholder survives once content lands on it) cannot drop them. U+00A0 counts as visible
// because it serialises as &nbsp;, matching the string trim.
export function trimAfterLastVisibleCharacter(html: string): string {
  const template = document.createElement('template');
  template.innerHTML = html;

  let last: Text | null = null;
  let end = -1;
  const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT);
  for (let node = walker.nextNode() as Text | null; node; node = walker.nextNode() as Text | null) {
    const index = lastVisibleIndex(node.data);
    if (index !== -1) {
      last = node;
      end = index;
    }
  }
  if (!last) return '';

  last.data = last.data.slice(0, end + 1);
  for (let node: Node = last; node.parentNode; node = node.parentNode) {
    while (node.nextSibling) node.nextSibling.remove();
  }
  return template.innerHTML;
}

// Document span a delta touched, in new-document indices. A delete adds no length but marks where it happened.
export function changedRange(ops: any[]): { start: number; end: number } | null {
  let position = 0;
  let start = -1;
  let end = -1;

  for (const op of ops) {
    if (op.retain !== undefined) {
      position += typeof op.retain === 'number' ? op.retain : 1;
      continue;
    }
    if (start === -1) start = position;
    if (op.insert !== undefined) position += typeof op.insert === 'string' ? op.insert.length : 1;
    end = position;
  }
  return start === -1 ? null : { start, end };
}

// `conversions` are in ascending original indices. A caret inside a token or at its end lands after the pill.
export function indexAfterConversions(index: number, conversions: { start: number; length: number }[]): number {
  let shift = 0;
  for (const { start, length } of conversions) {
    if (index <= start) break;
    if (index <= start + length) return start - shift + 1;
    shift += length - 1;
  }
  return index - shift;
}

function lastVisibleIndex(text: string): number {
  for (let i = text.length - 1; i >= 0; i--) {
    if (text[i] === '\u00a0' || text[i].trim() !== '') return i;
  }
  return -1;
}
